export default {"src":"/_next/static/media/high-five.colour.0a559376.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};